import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const SubstanceConcernsSection = ({
  sessionFormData,
  updateFormData,
  alcoholError,
  cannabisError,
  tobaccoError,
  illicitDrugsError,
  setAlcoholError,
  setCannabisError,
  setTobaccoError,
  setIllicitDrugsError,
  handleSubstanceTextareaChange
}) => {
  return (
    <Card id="substance-use" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Substance Use
      </h3>

      <div className={styles.substanceFieldRow}>
        <div className={styles.substanceFieldItem}>
          <label className={styles.labelMinWidth}>
            Alcohol
          </label>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <select
              value={sessionFormData.alcohol || ""}
              onChange={(e) => {
                updateFormData("alcohol", e.target.value);
                updateFormData("alcoholDetails", "");
                if (alcoholError && e.target.value && e.target.value !== "" && e.target.value !== "-") {
                  setAlcoholError("");
                }
              }}
              className={styles.selectSubstance}
            >
              <option value="">-</option>
              <option value="None">None</option>
              <option value="Past Use">Past Use</option>
              <option value="Occasional Use">Occasional Use</option>
              <option value="Regular Use">Regular Use</option>
              <option value="Daily Use">Daily Use</option>
              <option value="Unknown / Not Assessed">Unknown / Not Assessed</option>
            </select>
            {alcoholError && (
              <div className={styles.errorMessage} style={{ marginTop: "4px", marginBottom: "8px" }}>
                {alcoholError}
              </div>
            )}
            {sessionFormData.alcohol && sessionFormData.alcohol !== "-" && sessionFormData.alcohol !== "None" && sessionFormData.alcohol !== "Unknown / Not Assessed" && (
              <textarea
                id="alcohol-details-textarea"
                value={sessionFormData.alcoholDetails || ""}
                onChange={(e) => {
                  handleSubstanceTextareaChange(e.target, (value) => updateFormData("alcoholDetails", value), e.target.value);
                }}
                placeholder="Add details about alcohol use"
                className={styles.substanceDetailsTextarea}
                maxLength={500}
              />
            )}
          </div>
        </div>

        <div className={styles.substanceFieldItem}>
          <label className={styles.labelMinWidth}>
            Cannabis
          </label>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <select
              value={sessionFormData.cannabis || ""}
              onChange={(e) => {
                updateFormData("cannabis", e.target.value);
                updateFormData("cannabisDetails", "");
                if (cannabisError && e.target.value && e.target.value !== "" && e.target.value !== "-") {
                  setCannabisError("");
                }
              }}
              className={styles.selectSubstance}
            >
              <option value="">-</option>
              <option value="None">None</option>
              <option value="Past Use">Past Use</option>
              <option value="Occasional Use">Occasional Use</option>
              <option value="Regular Use">Regular Use</option>
              <option value="Daily Use">Daily Use</option>
              <option value="Unknown / Not Assessed">Unknown / Not Assessed</option>
            </select>
            {cannabisError && (
              <div className={styles.errorMessage} style={{ marginTop: "4px", marginBottom: "8px" }}>
                {cannabisError}
              </div>
            )}
            {sessionFormData.cannabis && sessionFormData.cannabis !== "-" && sessionFormData.cannabis !== "None" && sessionFormData.cannabis !== "Unknown / Not Assessed" && (
              <textarea
                id="cannabis-details-textarea"
                value={sessionFormData.cannabisDetails || ""}
                onChange={(e) => {
                  handleSubstanceTextareaChange(e.target, (value) => updateFormData("cannabisDetails", value), e.target.value);
                }}
                placeholder="Add details about cannabis use"
                className={styles.substanceDetailsTextarea}
                maxLength={500}
              />
            )}
          </div>
        </div>

        <div className={styles.substanceFieldItem}>
          <label className={styles.labelMinWidth}>
            Tobacco
          </label>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <select
              value={sessionFormData.tobacco || ""}
              onChange={(e) => {
                updateFormData("tobacco", e.target.value);
                updateFormData("tobaccoDetails", "");
                if (tobaccoError && e.target.value && e.target.value !== "" && e.target.value !== "-") {
                  setTobaccoError("");
                }
              }}
              className={styles.selectSubstance}
            >
              <option value="">-</option>
              <option value="None">None</option>
              <option value="Past Use">Past Use</option>
              <option value="Occasional Use">Occasional Use</option>
              <option value="Regular Use">Regular Use</option>
              <option value="Daily Use">Daily Use</option>
              <option value="Unknown / Not Assessed">Unknown / Not Assessed</option>
            </select>
            {tobaccoError && (
              <div className={styles.errorMessage} style={{ marginTop: "4px", marginBottom: "8px" }}>
                {tobaccoError}
              </div>
            )}
            {sessionFormData.tobacco && sessionFormData.tobacco !== "-" && sessionFormData.tobacco !== "None" && sessionFormData.tobacco !== "Unknown / Not Assessed" && (
              <textarea
                id="tobacco-details-textarea"
                value={sessionFormData.tobaccoDetails || ""}
                onChange={(e) => {
                  handleSubstanceTextareaChange(e.target, (value) => updateFormData("tobaccoDetails", value), e.target.value);
                }}
                placeholder="Add details about tobacco use"
                className={styles.substanceDetailsTextarea}
                maxLength={500}
              />
            )}
          </div>
        </div>

        <div className={styles.substanceFieldItem}>
          <label className={styles.labelMinWidth}>
            Illicit Drugs
          </label>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <select
              value={sessionFormData.illicitDrugs || ""}
              onChange={(e) => {
                updateFormData("illicitDrugs", e.target.value);
                updateFormData("illicitDrugsDetails", "");
                if (illicitDrugsError && e.target.value && e.target.value !== "" && e.target.value !== "-") {
                  setIllicitDrugsError("");
                }
              }}
              className={styles.selectSubstance}
            >
              <option value="">-</option>
              <option value="None">None</option>
              <option value="Past Use">Past Use</option>
              <option value="Occasional Use">Occasional Use</option>
              <option value="Regular Use">Regular Use</option>
              <option value="Daily Use">Daily Use</option>
              <option value="Unknown / Not Assessed">Unknown / Not Assessed</option>
            </select>
            {illicitDrugsError && (
              <div className={styles.errorMessage} style={{ marginTop: "4px", marginBottom: "8px" }}>
                {illicitDrugsError}
              </div>
            )}
            {sessionFormData.illicitDrugs && sessionFormData.illicitDrugs !== "-" && sessionFormData.illicitDrugs !== "None" && sessionFormData.illicitDrugs !== "Unknown / Not Assessed" && (
              <textarea
                id="illicit-drugs-details-textarea"
                value={sessionFormData.illicitDrugsDetails || ""}
                onChange={(e) => {
                  handleSubstanceTextareaChange(e.target, (value) => updateFormData("illicitDrugsDetails", value), e.target.value);
                }}
                placeholder="Add details about illicit drug use"
                className={styles.substanceDetailsTextarea}
                maxLength={500}
              />
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SubstanceConcernsSection;

